import PropTypes from 'prop-types';
import Description from 'Shared/components/description';
import Button from 'Shared/components/button';
import styles from './error-message.css';


const ErrorMessage = ({
  text,
  buttonText,
  onButtonClick,
}) => (
  <div className={styles.container}>
    <Description
      text={text}
    />
    <Button
      buttonType="action-primary"
      text={buttonText}
      onClick={onButtonClick}
      className={styles.button}
    />
  </div>
);

ErrorMessage.propTypes = {
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

export default ErrorMessage;
